"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleCloseEventsEnum = void 0;
var ScheduleCloseEventsEnum;
(function (ScheduleCloseEventsEnum) {
    ScheduleCloseEventsEnum["START_DATE"] = "2026-01-28";
    ScheduleCloseEventsEnum["JOB_TIME"] = "04:00:00";
    ScheduleCloseEventsEnum[ScheduleCloseEventsEnum["ACTIVE"] = 1] = "ACTIVE";
    ScheduleCloseEventsEnum[ScheduleCloseEventsEnum["DEFAULT_SCHOOL_GROUP_ID"] = 0] = "DEFAULT_SCHOOL_GROUP_ID";
    ScheduleCloseEventsEnum[ScheduleCloseEventsEnum["DEFAULT_ID"] = 0] = "DEFAULT_ID";
})(ScheduleCloseEventsEnum || (exports.ScheduleCloseEventsEnum = ScheduleCloseEventsEnum = {}));
